



































import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'

import ShortVideosManageForm from '~/components/shared/short-videos/ShortVideosManageForm.vue'
import {
  CLASSIFIED_FORM_NS,
  FormState
} from '~/store/modules/shared/classifieds/form/state'
import { ShortVideo, ShortVideoStatus } from '~/models/short-video'
import { defineComponentTranslations } from '~/utils/i18n'

import CImg from '~/components/shared/configurable/image/CImg.vue'
import { useNamespacedStore } from '~/compositions/store'
import { CLASSIFIED_EDIT_NS } from '~/store/modules/shared/classifieds/edit/state'

export default defineComponent({
  components: {
    ShortVideosManageForm,
    CImg
  },

  props: formFieldProps,
  setup(props) {
    const { name, fieldValue } = toRefs(props)
    const { state } = useNamespacedStore<FormState>(CLASSIFIED_FORM_NS)
    const { state: classifiedEditState } = useNamespacedStore(
      CLASSIFIED_EDIT_NS
    )
    const { valueChanged } = useClassifiedForm(props)

    const classifiedId = computed(() =>
      state.editMode ? state.classifiedId : null
    )
    const isClassifiedHidden = computed(() => classifiedEditState.info?.hidden)
    function handleUploadComplete(video: ShortVideo) {
      const values = fieldValue.value?.order || fieldValue.value
      valueChanged(
        name.value,
        values
          ? [...values, { id: video.id, name: video.description }]
          : [{ id: video.id, name: video.description }]
      )
    }
    function handleDelete(video: ShortVideo) {
      const values = fieldValue.value?.order || fieldValue.value
      if (values) {
        valueChanged(
          name.value,
          (values as any[]).filter(f => f.id !== video.id)
        )
      }
    }

    function handleSave({
      video,
      description
    }: {
      video: ShortVideo
      description: string
    }) {
      const values = fieldValue.value?.order || fieldValue.value
      if (values) {
        const index = values.findIndex(v => v.id === video.id)
        if (index >= 0) {
          values[index] = { id: video.id, name: description }
          valueChanged(name.value, values)
        }
      }
    }

    function handleChangeOrder(shorts: ShortVideo[]) {
      if (classifiedId.value) {
        valueChanged(
          name.value,
          shorts
            .filter(v => v.status === ShortVideoStatus.PUBLIC)
            .map(s => {
              return { id: s.id, name: s.description }
            })
        )
      } else {
        valueChanged(
          name.value,
          shorts.map(s => {
            return { id: s.id, name: s.description }
          })
        )
      }
    }

    return {
      classifiedId,
      handleDelete,
      handleSave,
      handleUploadComplete,
      handleChangeOrder,
      isClassifiedHidden
    }
  },
  i18n: defineComponentTranslations({
    video_duration: {
      en:
        'The duration of the video can be <strong>from 5 sec to 1 min</strong>',
      el:
        'Η διάρκεια του βίντεο μπορεί να είναι <strong>από 5 δευτερόλεπτα μέχρι 1 λεπτό</strong>'
    },
    video_orientation: {
      en: 'The video should be <strong>vertical/portrait</strong>',
      el: 'Τo βίντεο πρέπει να είναι σε <strong>κάθετη/όρθια θέση</strong>'
    },
    max_videos: {
      en: 'You can upload <strong>up to 3 videos</strong>',
      el: 'Μπορείς να ανεβάσεις <strong>έως και 3 βίντεο</strong>'
    }
  })
})
